import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, WingBlank, WhiteSpace } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import '../styles/AgentBill.css'

const history = require("history").createHashHistory()
const billTypes = {
    'SOLD_CASH_PACKET': '游戏套餐(微信)',
    'SOLD_COUPON_PACKET': '游戏套餐(余额)',
    'SOLD_RECHARGE': '优惠充值',
    'SOLD_COUPON': '优惠活动',
    'TEAM_SOLD_CASH_PACKET': '团队提成(游戏)',
    'TEAM_SOLD_RECHARGE': '团队提成(充值)',
    'TEAM_SOLD_COUPON': '团队提成(活动)',
    'WITHDRAW': '手动提现',
    'WITHDRAW_ROLLBACK': '手动提现驳回',
    'WITHDRAW_QFL': '自动提现',
    'WITHDRAW_QFL_ROLLBACK': '自动提现回滚',
    'REFUND': '订单退款',
    'TEAM_REFUND': '团队退款'
}

class AgentBill extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 80;
        this.setState({
            height
        })
        this.loadPageData(1, height)
    }

    loadPageData = (pageNum) => {
        DataFetcher.agentBills({
            pageNum,
            pageSize: 20,
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : []
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages
                })
            }
        })
    }

    onEndReached = (event) => {
        if (this.state.isLoading || !this.state.hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.map((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
            return data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    renderRow = (rowData, sectionId, rowId) => {

        return (
            <WingBlank size='sm' key={rowId}>
                <div className='row'>
                    <div className='icon'>
                        <i className='iconfont icon-31' style={{color: `${rowData.profitAmount>=0?'#04bbc5':'red'}`}}/>
                    </div>
                    <div className='info'>
                        <div className='description word-ellipsis'>
                            <span>{billTypes[rowData.operateType]?billTypes[rowData.operateType]:'账户变动'}&nbsp;&nbsp;</span>
                        </div>
                        <div className='remark word-ellipsis'>{rowData.createTime}</div>
                    </div>
                    <div className={`amount ${rowData.profitAmount>=0?'positive':'negative'}`}>
                        <span className='sign'>{rowData.profitAmount>=0?'+':'-'}</span>
                        <span className='symbol'>￥</span>
                        <span className='value'>{rowData.profitAmount>=0?rowData.profitAmount:-rowData.profitAmount}</span>
                    </div>
                </div>
            </WingBlank>
        )
    }

    render() {
        const {dataSource, isLoading} = this.state;
        return (
            <div className='page-agent-bill'>
                <NavBar mode="light" className='fixed' icon={<Icon type="left" color="black" size="md"/>} onLeftClick={history.goBack}>账户明细</NavBar>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 50
                    }}
                />
            </div>
        )
    }
}

export default AgentBill;


// WEBPACK FOOTER //
// ./src/modules/AgentBill.js